import PropTypes from 'prop-types';
import { Modal } from '@mui/material';
import { colors } from '../../../../../colorVars';
import TextButton from '../../../../atomic/buttons/textButton/TextButton';
import { Heading4 } from '../../../../atomic/text/Text';
import style from './ApplyChangesModal.module.css';
import { sendUserPreferences } from '../../../../../stores/websocketStore/utils/outgoingMessages/userpreferences/sendUserPreferences';
import { requestUserPreferences } from '../../../../../stores/websocketStore/utils/outgoingMessages/userpreferences/requestUserPreferences';

export const ApplyChangesModal = ({ open, handleClose, userPrefs }) => {
  return (
    <Modal
      open={open}
      onClose={handleClose}
      onBackdropClick={() => {
        handleClose();
        requestUserPreferences();     // TODO aren't these stored somewhere??
      }}
    >
      <div className={style.container}>
        <div className={style.text}>
          <p>
            <Heading4 fontWeight={700} color={colors.lightGrey}>
              Apply changes to user preferences?{' '}
            </Heading4>
          </p>
        </div>
        <div className={style.buttons}>
          <TextButton
            fontSize="medium"
            backgroundColor={colors.blue}
            color={colors.lightGrey}
            clickHandler={() => {
              handleClose();
              sendUserPreferences(userPrefs);
            }}
            width="60px"
          >
            Apply
          </TextButton>
          <TextButton
            fontSize="medium"
            backgroundColor={colors.red}
            color={colors.lightGrey}
            clickHandler={() => {
              handleClose();
              requestUserPreferences();     // TODO aren't these stored somewhere??
            }}
            width="60px"
          >
            Cancel
          </TextButton>
        </div>
      </div>
    </Modal>
  );
};

ApplyChangesModal.propTypes = {
  handleClose: PropTypes.any,
  open: PropTypes.any,
};
